import { render } from "./FeedbackTwo.vue?vue&type=template&id=1fd13deb"
import script from "./FeedbackTwo.vue?vue&type=script&lang=js"
export * from "./FeedbackTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__